import locale from "localization/en";

export const dryStockDeliveriesColumn = [
  { key: "deliveryId", text: locale.deliveryId },
  { key: "dateAndTime", text: locale.dateAndTime },
  { key: "poReferenceNumber", text: locale.poReferenceNumber },
  { key: "plateNumber", text: locale.plateNumber },
  { key: "witnesses", text: locale.witnesses },
];
export const dryStockDeliveryProductsColumn = [
  { key: "deliveryId", text: locale.deliveryId },
  { key: "poReferenceNumber", text: locale.poReferenceNumber },
  { key: "itemCode", text: locale.itemCode },
  { key: "product", text: locale.product },
  { key: "beforeReceiving", text: locale.beforeReceiving },
  { key: "quantityDelivered", text: locale.quantityDelivered },
  { key: "afterReceiving", text: locale.afterReceivingDS },
  { key: "variance", text: locale.variance, width: "200px" },
];
